import React from 'react'
import PropTypes from 'prop-types'
import { Breadcrumb, Breadcrumbs } from '@chilecompra/react-kit/components'
import { Navigation, Root } from './HeadingSection.styles'

/**
 * The HeadingSection's container.
 */
const HeadingSection = ({ breadcrumbs }) => {
  return (
    <Root>
      <Navigation>
        <Breadcrumbs>
          {breadcrumbs.map((breadcrumb, index) =>
            breadcrumb.link ? (
              breadcrumb.isExternal ? (
                <Breadcrumb
                  key={`breadcrumb-link-${index}`}
                  target="_top"
                  to={breadcrumb.link}
                  type="external"
                  variant="link"
                  onClick={breadcrumb.onClick || undefined}
                  tabIndex="0"
                >
                  {breadcrumb.text}
                </Breadcrumb>
              ) : (
                <Breadcrumb key={`breadcrumb-link-${index}`} to={breadcrumb.link} variant="link" tabIndex="0">
                  {breadcrumb.text}
                </Breadcrumb>
              )
            ) : (
              <Breadcrumb key={`breadcrumb-text-${index}`} variant="text" tabIndex="0">
                {breadcrumb.text}
              </Breadcrumb>
            )
          )}
        </Breadcrumbs>
      </Navigation>
    </Root>
  )
}

HeadingSection.defaultProps = {
  breadcrumbs: [],
  title: ''
}

HeadingSection.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      isExternal: PropTypes.bool,
      link: PropTypes.string,
      text: PropTypes.string.isRequired
    })
  ).isRequired
}

export default HeadingSection
